import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

// 页面组件 - 修改后的组件导入（添加前缀）
import AppDashboard from '../views/Dashboard.vue'
import AccountManagement from '../views/AccountManagement.vue'
import AdvertiserManagement from '../views/AdvertiserManagement.vue'

import PlatformManagement from '../views/PlatformManagement.vue'

import MaterialGallery from '../views/material/Gallery.vue'

import SystemPublish from '../views/system/Publish.vue'
import SmsManagement from '../views/system/SmsManagement.vue'
import SystemOssConfig from '../views/system/OssConfig.vue'

import UserManagement from '../views/store/UserManagement.vue'
import BusinessCardManagement from '../views/store/BusinessCardManagement.vue'

import NumberManagement from '../views/NumberManagement.vue'

import ScheduledDelivery from '../views/ScheduledDelivery.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      // 控制台
      {
        path: 'dashboard',
        name: 'AppDashboard',  // 修改名称
        component: AppDashboard
      },

      // 账号管理（已符合规范，无需修改）
      {
        path: 'account',
        name: 'AccountManagement',
        component: AccountManagement
      },

      {
        path: 'Advertiser',
        name: 'AdvertiserManagement',
        component: AdvertiserManagement
      },

      {
        path: 'NumberManagement',
        name: 'NumberManagement',
        component: NumberManagement
      },

      {
        path: 'ScheduledDelivery',
        name: 'ScheduledDelivery',
        component: ScheduledDelivery
      },
      // 素材管理
      {
        path: 'material',
        children: [

          {
            path: 'gallery',
            name: 'MaterialGallery',
            component: MaterialGallery
          }
        ]
      },

      // 素材管理
      {
        path: 'store',
        children: [

          {
            path: 'usermanagement',
            name: 'UserManagement',
            component: UserManagement
          },
          {
            path: 'businesscard',
            name: 'BusinessCardManagement',
            component: BusinessCardManagement
          }
        ]
      },
      // 系统配置
      {
        path: 'system',
        children: [

          {
            path: 'publish',
            name: 'SystemPublish',
            component: SystemPublish
          },
          {
            path: 'OssConfig',
            name: 'SystemOssConfig',
            component: SystemOssConfig
          },
          {
            path: 'platform',
            name: 'PlatformManagement',
            component: PlatformManagement
          },
          {
            path: 'smsmanagement',
            name: 'SmsManagement',
            component: SmsManagement
          }
        ]
      }
    ]
  }
]


const router = createRouter({
  history: createWebHashHistory('/shop/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLoginPage = to.path === '/login'

  // 认证检查逻辑
  if (requiresAuth) {
    if (isAuthenticated) {
      // 已认证访问管理后台
      if (to.path === '/') {
        // 默认跳转控制台
        next('/dashboard')
        return
      }
      next()
    } else {
      // 未认证重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else if (isLoginPage) {
    // 登录页特殊处理
    if (isAuthenticated) {
      next('/dashboard') // 已登录强制跳转控制台
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router